// extracted by mini-css-extract-plugin
export var arrows = "_7j-6";
export var decrementer = "_7j-a";
export var disabled = "_7j-4";
export var error = "_7j-1";
export var hiddenText = "_7j-b";
export var incrementer = "_7j-9";
export var input = "_7j-8";
export var inputWrapper = "_7j-0";
export var leadingIcon = "_7j-c";
export var readonly = "_7j-3";
export var regular = "_7j-7";
export var small = "_7j-5";
export var warning = "_7j-2";